<template>
    <div class="b-statistics-filters">
        <div class="b-statistics-filters__cont">
            <a href="javascript:void(0)" class="b-statistics-filters__close icon-close" @click="closeSearch"></a>
            <div class="b-statistics-filters__cont__inner">
                <div class="b-statistics-filters__form">
                    <div class="b-statistics-filters__form__inputs">
                        <div class="b-statistics-filters__form__row">
                            <div class="b-statistics-filters__input">
                                <select id="category-input" v-model="category" class="custom-select">
                                    <option
                                        v-for="(option, i) in appData?.filters?.categories"
                                        :key="'category-' + i"
                                        :value="option.value">
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="b-statistics-filters__form__row">
                            <div v-if="appData.dictionary.filtersNote" class="b-statistics-filters__form__text">
                                <article class="b-article" v-html="appData.dictionary.filtersNote"></article>
                            </div>
                            <div class="b-statistics-filters__input">
                                <select id="region-input" v-model="region" class="custom-select">
                                    <option
                                        v-for="(option, i) in appData?.filters?.regions"
                                        :key="'region-' + i"
                                        :value="option.value">
                                        {{ option.text }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="b-statistics-filters__form__row">
                            <div class="b-statistics-filters__input">
                                <ul class="b-statistics-filters__radios">
                                    <li v-for="(option, i) in appData?.filters?.actionTypes" :key="'action-' + i">
                                        <label :for="'action-' + i" class="custom-check">
                                            <input
                                                :id="'action-' + i"
                                                v-model="actionType"
                                                type="radio"
                                                name="actionTypes"
                                                :value="option.value" />
                                            <span class="custom-check__label">{{ option.text }}</span>
                                        </label>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="b-statistics-filters__form__submit">
                        <a href="javascript:void(0)" class="e-btn" @click="submitClicked">
                            {{ appData.dictionary.submitBtn }}
                        </a>
                    </div>
                    <div class="b-statistics-filters__form__submit-sticky">
                        <a href="javascript:void(0)" class="dotted-link" @click="submitClicked">
                            <span>{{ appData.dictionary.submitStickyBtn }}</span>
                        </a>
                    </div>
                </div>
                <div v-if="resultsTabs?.links" class="b-statistics-filters__tabs">
                    <div v-for="tab in resultsTabs?.links" :key="tab.id" class="b-statistics-filters__tabs__item">
                        <a
                            href="javascript:void(0)"
                            :class="['dotted-link', { active: tab.id === resultsTabs.activeId }]"
                            @click="resultsTabLinkClicked(tab.id)">
                            {{ tab.text }}
                            <template
                                v-if="
                                    (tab.id === 'byMonth' || tab.id === 'byMonthMO') &&
                                    results.byMonthYearsPeriod?.length === 2
                                ">
                                ({{ results.byMonthYearsPeriod[0] }} - {{ results.byMonthYearsPeriod[1] }})
                            </template>
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="b-statistics-filters__mob-toggler">
            <div class="e-btn">{{ appData.dictionary.mobileFiltersButton }}</div>
        </div>
    </div>
</template>

<script>
import * as lib from 'Root/lib/lib.js'
import CustomSelectUI from 'Root/ui/components/CustomSelectUI.js'
import StatisticsStickyFilters from 'Root/ui/components/StatisticsStickyFilters.js'

export default {
    props: {
        results: {
            type: Object,
            default: () => {
                return {}
            },
        },
        resultsTabs: {
            type: Object,
            default: () => {
                return {}
            },
        },
    },

    emits: ['submit-clicked', 'results-tabs-link-clicked'],

    data() {
        return {
            category: null,
            region: null,
            actionType: null,
        }
    },

    mounted() {
        this.category = this.appData?.filters?.categories[0].value
        this.region = this.appData?.filters?.regions[0].value
        this.actionType = this.appData?.filters?.actionTypes[0].value

        this.$nextTick(() => {
            this.$el.querySelectorAll('.custom-select').forEach((elem) => {
                elem.CustomSelect = new CustomSelectUI(elem)
            })

            this._iniStickyFilters()
        })
    },

    methods: {
        _iniStickyFilters() {
            this.$el.StatisticsStickyFilters = new StatisticsStickyFilters(this.$el)
        },

        submitClicked() {
            const filters = {
                category: this.category,
                region: this.region,
                actionType: this.actionType,
            }

            this.$emit('submit-clicked', filters)

            if (window.innerWidth < lib.breakpoints.desktop) {
                this.$el.StatisticsStickyFilters.closeMobFilters()
            }
        },

        resultsTabLinkClicked(id) {
            this.$emit('results-tabs-link-clicked', id)

            if (window.innerWidth < lib.breakpoints.desktop) {
                this.$el.StatisticsStickyFilters.closeMobFilters()
            }
        },
    },
}
</script>
